import { PlatformHealthPlaceholder } from "./PlatformHealthPlaceholder";

export function ProdDeploysPage() {
  return (
    <PlatformHealthPlaceholder
      title="Prod Deploys"
      subtitle="History and status of production deploys"
    />
  );
}
